import { render, staticRenderFns } from "./historyVisitorInfo.vue?vue&type=template&id=90b164e0&"
import script from "./historyVisitorInfo.vue?vue&type=script&lang=js&"
export * from "./historyVisitorInfo.vue?vue&type=script&lang=js&"
import style0 from "./historyVisitorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports